import { render, staticRenderFns } from "./Consumos.vue?vue&type=template&id=311c6ace"
import script from "./Consumos.vue?vue&type=script&lang=js"
export * from "./Consumos.vue?vue&type=script&lang=js"
import style0 from "./Consumos.vue?vue&type=style&index=0&id=311c6ace&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports